export default {
  comparison: {
    contain: '包含',
    does_not_contain: '不包含',
    s_equal: '等于',
    s_does_not_equal: '不等于',
    equal: '等于',
    does_not_equal: '不等于',
    greater_than: '大于',
    greater_than_or_equal: '大于等于',
    less_than: '小于',
    less_than_or_equal: '小于等于',
    in: '等于',
    not_in: '不等于',
    d_equal: '等于',
    d_does_not_equal: '不等于',
    d_greater_than: '大于',
    d_greater_than_or_equal: '大于等于',
    d_less_than: '小于',
    d_less_than_or_equal: '小于等于',
  },
  receive_type: {
    cho_xep_xe: '等待装车',
    xep_xe: '装车',
    cho_thong_quan_tq: '等待中国清关',
    kiem_hoa: '查验',
    cho_thong_quan_vn: '等待越南清关',
    nhap_kho_vn: '入越南仓',
  },
  bill_status: {
    chua_xuat: '未出库',
    da_xuat: '已出库',
    da_thanh_toan: '已付款',
  },
  price_type: {
    tu_dong: '自动',
    theo_can: '按重量',
    theo_khoi: '按体积',
  },
  product_status: {
    nhap_kho_tq: '入中国仓',
    cho_xep_xe: '等待装车',
    xep_xe: '中国装车',
    cho_thong_quan_tq: '等待中国清关',
    kiem_hoa: '查验',
    cho_thong_quan_vn: '等待越南清关',
    nhap_kho_vn: '入越南仓',
    xuat_thieu: '部分出库',
    xuat_du: '全部出库',
  },
  order_status: {
    all: '所有状态',
    cancel: '取消订单',
    quote_pending: '等待报价',
    deposit_pending: '等待预付',
    deposited: '已预付',
    purchased: '已采购',
    shop_shipped: '商店发货',
    cn_warehouse: '已入中国仓',
    vn_shipping: '运输到越南',
    vn_warehouse: '已入越南仓',
    exported: '已出库',
    complaint: '投诉',
    completed: '已完成'
  },
  order_deposit_status: {
    cancel: '取消订单',
    shop_shipped: '商店发货',
    cn_warehouse: '已入中国仓',
    vn_shipping: '运输到越南',
    vn_warehouse: '已入越南仓',
    payment_pending: '等待付款',
    exported: '已出库',
    completed: '已完成'
  },
  package_status: {
    not_shipped: '未发货',
    shipping: '运输中',
    cn_warehouse: '已到中国仓',
    vn_shipping: '运输到越南',
    vn_warehouse: '已到越南仓',
    delivered: '已送达'
  },
  big_package: {
    headers: {
      package_code: '批號',
      big_export_id: '出貨單號',
      status: '地位',
      store_exp_id: '收貨倉庫',
      product_name: '產品名稱',
      number_of_pack: '代碼總數',
      total_small_pack: '總包數',
      weight: '總重量',
      volume: '總容積',
      amount: '郵資',
      phone_number: '電話號碼',
      address: '地址',
      store_phone_number: '車牌',
      ex_date: '交貨日期',
      im_date: '收到貨物日期',
      state: '地位',
      payment_status: '支付',
      created_by: '創作者',
      note: '筆記',
      action: '手術'
    }
  },
  profit_stats: {
    headers: {
      staff: '员工',
      completed_orders: '已完成订单数',
      completed_links: '已完成链接数',
      total_order_amount: '订单总金额',
      total_real_amount: '实际购买总金额',
      total_diff: '总差额',
      total_completed_order_amount: '已完成订单总金额',
      total_completed_real_amount: '已完成实际购买总金额',
      total_completed_diff: '已完成总差额',
      reward: '奖励'
    }
  },
  // Order headers
  order: {
    headers: {
      order_id: '订单编号',
      product_image: '产品图片',
      total_amount: '总金额',
      min_deposit: '需预付',
      customer: '客户',
      buyer: '采购',
      cs: '客服',
      sale: '销售',
      note: '备注',
      status: '状态',
      action: '操作',
      support_staff: '支持人员',
      wooden_pack: '木箱',
      check_goods: '验货',
      guarantee: '保险',
      created_date: '下单日期',
      deposit_date: '预付日期',
      bought_date: '采购日期',
      shop_deliver_date: '发货日期',
      store_cn_im_date: '入中国仓',
      store_cn_ex_date: '出中国仓',
      store_vn_im_date: '入越南仓',
      payment_date: '付款日期',
      completed_date: '完成日期'
    }
  },
  customer: {
    headers: {
      id: 'ID',
      username: '客户',
      first_name: '姓',
      last_name: '名',
      email: '邮箱',
      phone: '电话',
      address: '地址',
      level: '等级',
      status: '状态',
      purchase_name: '采购',
      cs_name: '客服',
      sale_name: '销售',
      price_id: '价格表',
      note: '备注',
      total_transaction: '累计交易',
      wallet: '钱包余额',
      created_date: '创建日期',
      modified_date: '修改日期',
      modified_by: '修改人',
      action: '操作'
    }
  },
  // PaymentHistory headers
  payment_history: {
    headers: {
      id: 'ID',
      order_id: '订单编号',
      waiting_for_truck: '等待装车',
      on_the_way: '已装车',
      processing_tq: '等待中国清关',
      check: '查验',
      processing_vn: '等待越南清关',
      import_vn: '入越南仓',
      exported: '已出库',
      no_owner: '无主货物',
      product_inventory_in_tq: '中国库存',
      product_inventory_in_vn: '越南库存',
      truck_detail: '卡车详情',
      bill_detail: '出库详情',
      amount: '金额',
      customer: '客户',
      type: '交易类型',
      created_date: '创建日期',
      created_by: '创建人'
    }
  },
  // ProductType headers
  product_type: {
    headers: {
      id: 'ID',
      name: '商品类型名称',
      active: '启用',
      active_true: '启用',
      active_false: '未启用',
      modified_date: '修改日期',
      modified_by: '修改人',
      action: '操作'
    }
  },
  // CustomerLevel headers
  customer_level: {
    headers: {
      name: '等级名称',
      discount_fee_buy: '代购费折扣',
      discount_fee_weight: '重量费折扣',
      min_deposit: '最低预付',
      action: '操作'
    }
  },
  // DebtReport headers
  debt_report: {
    headers: {
      customer: '客户',
      deposit: '充值',
      order_amount: '货款',
      wallet: '钱包余额',
      wallet_theory: '理论余额',
      debt_arrived: '已到货欠款',
      debt_not_arrived: '未到货欠款',
      note: '备注'
    },
    debt_in: "应收账款",
    debt_out: "应付账款",
    total_debt: "总账款",
  },
  wallet_history: {
    headers: {
      id: 'ID',
      customer: '客户',
      trade_type: '交易类型',
      amount: '金额',
      balance: '余额',
      content: '内容',
      note: '备注',
      created_date: '创建日期',
      created_by: '创建人'
    }
  },
  dashboard: {
    order_title: '订单',
    deposit_title: '托运订单',
    list_bigpackages: '大包裹列表',
  },
  // Header và Navigation
  navigation: {
    dashboard: '首页',
    orders: '订单',
    packages: '包裹',
    customers: '客户',
    reports: '报告',
    settings: '设置',
    logout: '退出'
  },
  // Route titles
  routes: {
    login: '登录',
    profile: '账户',
    dashboard: '仪表板',
    orders: '订单',
    order_detail: '订单',
    orders_late_delivery: '配送延迟',
    orders_late_china_warehouse: '中国仓库延迟',
    orders_late_vn_warehouse: '越南仓库延迟',
    orders_late_customer: '客户延迟',
    orders_late_purchase: '采购延迟',
    customers: '客户',
    customer_detail: '客户',
    transaction_history: '交易历史',
    deposit: '托运订单',
    deposit_detail: '托运订单',
    admin_deposit: '托运订单',
    payment_history: '支付历史',
    withdrawal: '提现',
    payment_goods: '货款支付',
    payment_detail: '货款支付',
    tracking_code: '运单号',
    consignment: '寄售',
    consignment_detail: '寄售',
    consignment_late_china: '中国仓库延迟',
    consignment_late_vn: '越南仓库延迟',
    consignment_late_customer: '客户延迟',
    complaints: '投诉',
    complaint_detail: '投诉',
    china_warehouse: '中国仓库进出',
    vn_warehouse_import: '越南仓库入库',
    vn_warehouse_detail: '越南仓库入库',
    shipment: '运输',
    warehouse_export: '出库',
    order_control: '订单控制',
    cash_flow_yuan: '现金流（¥）',
    cash_flow_yuan_detail: '收支明细（¥）',
    cash_flow_vnd: '现金流（₫）',
    cash_flow_vnd_detail: '收支明细（₫）',
    shop_refund: '商店退款',
    refund_detail: '退款详情',
    quotes: '报价',
    quote_detail: '报价详情',
    shipping_fee_original: '原始运费',
    weight_fee: '重量费',
    weight_fee_detail: '重量费',
    volume_fee: '体积费',
    volume_fee_detail: '体积费',
    checking_fee: '检查费',
    checking_fee_detail: '检查费',
    insurance_fee: '保险费',
    insurance_fee_detail: '保险费',
    buying_fee: '代购费',
    buying_fee_detail: '代购费',
    guarantee_fee: '担保费',
    guarantee_fee_detail: '担保费',
    reinforcement_fee: '加固费',
    reinforcement_fee_detail: '加固费',
    address_book: '地址簿',
    address_book_detail: '地址簿',
    china_stores: '中国商店',
    china_store_detail: '中国商店',
    configurations: '配置',
    configuration_detail: '配置',
    user_management: '用户管理',
    user_detail: '用户管理',
    notification_management: '通知管理',
    notification_detail: '通知管理',
    customer_level: '客户等级',
    customer_level_detail: '客户等级',
    media: '媒体',
    daily_report: '日报',
    monthly_report: '月报',
    customer_report: '客户报告',
    debt_report: '债务报告',
    purchase_report: '采购报告',
    warehouse_report: '仓库报告',
    product_type: '商品类型',
    partner: '合作伙伴',
    general_config: '通用配置',
    staff: '员工',
    vip_customer: 'VIP客户',
    china_warehouse_config: '中国仓库',
    vn_warehouse_config: '越南仓库',
    shipping_price_list: '运费价格表',
    hashtag: '标签',
    notification: '通知',
    profit_report: '利润报告',
    order_profit_stats: '订单利润统计',
    buying_fee_stats: '代购费统计',
    shipping_fee_stats: '运费统计',
    currency_stats: '货币统计',
    finance: '财务',
    deposit_stats: '充值统计',
    revenue_report: '收入报告',
    debt_report_detail: '客户债务报告',
    staff_commission_stats: '员工佣金统计',
    sale_commission_tier: '销售奖金阶梯配置',
    sale_commission_staff: '员工奖金系数',
    shipment_report: '货运报告',
    china_warehouse_export: '中国仓库出库',
    payment_service: '代付服务',
    china_warehouse_finance: '中国仓库财务',
    china_warehouse_finance_detail: '收支明细',
    order_hashtag: '订单标签',
    delivery_request: '配送请求',
    delivery_request_detail: '配送请求详情',
    inventory_pending: '待配送库存',
    lost_items: '丢失物品',
    receiving_warehouse: '收货仓库',
    reports: '报告',
    settings: '设置',
    accountant: '会计',
    price_table: '运费价格表',
    payservice_report: '代付服务报告',
    business_report: '经营业绩报告',
    product_inventory: '产品库存',
    truck: '卡车',
    all: '全部',
    import_tq: '入中国仓',
    waiting_for_truck: '等待装车',
    on_the_way: '已装车',
    processing_tq: '等待中国清关',
    check: '查验',
    processing_vn: '等待越南清关',
    import_vn: '入越南仓',
    exported: '已出库',
    no_owner: '无主货物',
    product_inventory_in_tq: '中国库存',
    product_inventory_in_vn: '越南库存',
    truck_detail: '卡车详情',
    bill_detail: '出库详情',
    product_detail: '产品详情',
    audit_log: '操作日志',
    cost_weight: '价格成本',
  },
  // Common actions
  actions: {
    save: '保存',
    cancel: '取消',
    delete: '删除',
    edit: '编辑',
    add: '添加',
    search: '搜索',
    filter: '筛选',
    export: '导出',
    import: '导入',
    refresh: '刷新',
    submit: '提交',
    confirm: '确认',
    close: '关闭',
    view: '查看',
    update: '更新',
    create: '创建',
    print: '打印',
    print_label: '打印标签',
    edit_quote: '编辑报价',
    export_file: '导出文件',
    add_package: '添加包裹',
    add_fee: '添加费用'
  },
  dialog: {
    product_detail_title: '运单号详情',
    basic_info: '基本信息',
    fee_info: '费用信息',
    other_fees: '其他费用',
    product_specs: '产品规格',
    pricing_info: '价格信息',
    package_details: '包裹详情',
    cost_tax_info: '费用和税收信息',
    select_export_type: '选择导出文件类型',
    edit_quote_info: '编辑报价信息',
  },
  // Form labels
  form: {
    name: '姓名',
    email: '邮箱',
    phone: '电话号码',
    address: '地址',
    status: '状态',
    date: '日期',
    time: '时间',
    amount: '金额',
    quantity: '数量',
    weight: '重量',
    note: '备注',
    description: '描述',
    select_customer: '选择客户',
    select_storage: '选择仓库',
    box_code: '箱号',
    partner_name: '代理名称',
    select_quote: '选择报价',
    no_name: '无名称',
    no_quote: '没有报价',
    select_customer_first: '请先选择客户',
    notice_save_product: '添加包裹前请先保存产品！',
    hs_code: 'HS编码',
    total_amount: '总金额',
    created_date: '创建日期',
    product_name_cn: '产品名称',
    product_type: '货物类型',
    suffix_bill: '运单号',
    transaction_deposit: '国内运费 (¥)',
    pedicab_deposit: '三轮车费 (¥)',
    load_deposit: '叉车费 (¥)',
    other_fee: '其他费用 (¥)',
    exchange_rate: '汇率',
    volume: '总体积',
    number_of_pack: '总件数',
    price_type: '计费方式',
    weight_price: '重量价格',
    volume_price: '体积价格',
    weight_cost: '原始重量费',
    volume_cost: '原始体积费',
    product_amount: '货款 (đ)',
    import_tax_rate: '进口税率 (%)',
    vat_tax_rate: '增值税率 (%)',
    service_fee_rate: '服务费率 (%)',
    import_tax_amount: '进口税 (đ)',
    vat_tax_amount: '增值税 (đ)',
    service_fee_amount: '服务费 (đ)',
    self_fee: '额外费用 (đ)',
    self_fee_note: '额外备注',
    total_profit: '利润 (đ)',
    subtotal: '小计',
    image: '图片',
    choose_file: '选择文件',
    no_file_chosen: '未选择文件',
    add: '添加',
    length: '长',
    width: '宽',
    height: '高',
    weight_sub: '重量',
    number_of_pack_sub: '件数',
    no_data: '暂无数据',
    is_linked: '(已关联订单)',
    image: '图片',
    length: '长',
    width: '宽',
    height: '高',
    export_tieu_ngach: '导出文件-小额贸易',
    export_chinh_ngach: '导出文件-大额贸易',
    export_chinh_ngach_vi: '导出文件-大额贸易VN',
    product_brand: '品牌',
    product_capacity: '功率/容量',
    product_material: '商品材质',
    pack_type: '包装规格',
    product_size: '产品尺寸',
    total_product: '总产品数',
    yes: '是',
    no: '否',
    no_images: '暂无图片',
    fee_name: '费用名称',
    total: '总计',
  },
  // Status
  status: {
    active: '活跃',
    inactive: '非活跃',
    pending: '待处理',
    completed: '已完成',
    cancelled: '已取消',
    processing: '处理中'
  },
  // Messages
  messages: {
    success: '成功',
    error: '发生错误',
    warning: '警告',
    info: '信息',
    confirm_delete: '您确定要删除吗？',
    save_success: '保存成功',
    delete_success: '删除成功',
    update_success: '更新成功',
    no_data: '无数据'
  },

  // Notification messages
  notifications: {
    save_success: '保存成功',
    delete_success: '删除成功',
    update_success: '更新成功'
  },

  // Export messages
  export: {
    export_selected_items: '导出 {count} 个已选产品',
    export_all_items: '根据当前筛选条件导出所有产品',
    send_custom: '发送海关申报'
  },

  // Validation messages
  validation: {
    product_brand_required: '品牌是必填项'
  },

  // Error messages
  errors: {
    product_no_quote: '该产品尚无报价',
    cannot_load_quote_info: '加载报价信息时出错',
    cannot_update_quote: '更新报价信息时出错',
    save_failed: '保存失败',
    upload_failed: '上传失败'
  },

  // Success messages
  success: {
    quote_updated: '报价信息更新成功！'
  },
  // Order management
  orders: {
    title: '订单管理',
    order_code: '订单编号',
    customer_name: '客户姓名',
    order_date: '订单日期',
    total_amount: '总金额',
    shipping_fee: '运费',
    product_name: '产品名称',
    unit_price: '单价',
    create_order: '创建订单',
    order_details: '订单详情'
  },
  // Package management 
  packages: {
    title: '包裹管理',
    package_code: '包裹编号',
    tracking_number: '跟踪号码',
    sender: '发件人',
    receiver: '收件人',
    weight: '重量',
    dimensions: '尺寸',
    shipping_cost: '运费',
    create_package: '创建包裹'
  },
  // Customer management
  customers: {
    title: '客户管理',
    customer_code: '客户编号',
    full_name: '全名',
    phone_number: '电话号码',
    email_address: '邮箱地址',
    address: '地址',
    registration_date: '注册日期',
    customer_level: '客户等级',
    create_customer: '创建客户'
  },
  // Language
  language: {
    vietnamese: '越南语',
    chinese: '中文',
    select_language: '选择语言'
  },

  // Common table headers - 表格标题
  table_headers: {
    wallet: '已付款',
    suffix_bill: '运单号',
    deposit: '总支出',
    total_fee_weight: '总重量费用',
    import_tax_amount: '进口税',
    vat_tax_amount: '增值税',
    total_cost_weight: '总重量成本',
    total_profit: '总利润',
    receive_date: '收货日期',
    deliver_date: '交付日期',
    store_id: '收货仓库',
    id: 'ID',
    username: '用户名',
    box_code: '箱号',
    partner_name: '代理名称',
    order_codes: '订单编号',
    bill_codes: '账单编号',
    email: '邮箱',
    full_name: '姓名',
    first_name: '姓',
    last_name: '名',
    phone: '电话',
    address: '地址',
    status: '状态',
    action: '操作',
    created_date: '创建日期',
    modified_date: '修改日期',
    modified_by: '修改人',
    created_by: '创建人',
    note: '备注',
    is_split_tax: '是否拆分税费',
    is_ready: '是否准备好',
    // Customer headers
    customer_code: '客户编号',
    customer_name: '客户姓名',
    customer: '客户',
    total_deposit: '总充值',
    order_amount: '货款',
    debt: '欠款',
    sale_staff: '销售人员',
    level: '等级',
    role: '权限',

    // Quote headers
    quote_id: '报价编号',
    product_image: '产品图片',
    product_info: '商品类型名称',
    customs_content: '报关要求',
    customs_price_note: '税费和报关价格',
    customs_unit: '报关单位',
    hs_code: 'HS编码',
    product_number: '产品数量',
    customs_price_vnd: '需报关价格',
    import_tax: '进口税 (%)',
    vat_tax: '增值税 (%)',
    service_fee: '服务费 (%)',
    number_of_pack: '件数',
    weight: '重量',
    volume: '体积',
    is_quoted: '状态',

    // Product/Tracking headers
    tracking_code: '运单号',
    product_name: '商品名称',
    product_name_cn: '中文商品名',
    product_name_vn: '越南商品名',
    package_code: '包裹编号',
    bill_code: '账单',
    bill_id: '账单编号',
    total_cost_yuan: '总费用 (¥)',
    cost_yuan: '费用 (¥)',
    shipping_fee_yuan: '运费 (¥)',
    shipping_fee: '运费',
    shipping_cost: '运输费用',
    cn_warehouse_date: '入中国仓',
    package_date: '打包日期',
    vn_warehouse_date: '入越南仓',
    export_date: '出越南仓',
    remaining_pack: '剩余包裹',

    // Storage/Warehouse headers
    storage_name: '仓库名称',
    storage_cn: '中国仓库',
    storage_vn: '收货仓库',
    available: '可用',

    // Product Type headers
    product_type_name: '商品类型名称',
    product_type: '商品类型',

    // Fee headers
    fee_from_kg: '起 (kg)',
    fee_to_kg: '至 (kg)',
    fee_from_m3: '起 (m3)',
    fee_to_m3: '至 (m3)',
    unit_price: '单价',
    price_kg: '公斤价',
    price_m3: '立方价',

    // Payment headers
    amount: '金额',
    total_amount: '总金额',
    shipping_fee_label: '运费',
    other_fee: '其他费用',
    payment_date: '付款日期',
    content: '内容',

    // Recharge headers
    recharge_amount: '金额',
    trade_content: '交易内容',

    // Truck headers
    truck_code: '车辆编号',
    license_plate: '车牌号',
    license_plate_vn: '车牌号 (VN)',
    truck_date: '装车日期',
    tranfer_date: '装货日期',
    release_date: '还车日期',
    warehouse_date: '入库日期',
    order_count: '订单数',
    load_truck: '装车',
    export_warehouse: '出库',

    // BigPackage headers
    big_package_code: '包裹',
    warehouse_code: '入库编号',
    package_count: '包裹数',
    import_pack: '入库件数',
    import_kg: '入库重量',
    import_m3: '入库体积',

    // Report headers
    date: '日期',
    bill_count: '账单数',
    pack_count: '件数',
    discount: '折扣',
    subtotal: '小计',
    cost: '成本',
    profit: '利润',

    // Dimension headers
    length: '长',
    width: '宽',
    height: '高',

    // Additional headers
    exchange_rate: '汇率',
    original_weight_fee: '原始重量费',
    import_tax_fee: '进口税',
    vat_tax_fee: '增值税',
    service_fee_amount: '服务费',
    attributes: '属性',
    quantity: '数量',
    price_yuan: '价格 (¥)',
    total_yuan: '总计 (¥)',
    s_pack: '件数',
    kg: 'KG',
    m3: 'M3',
    number_of_code: '总单号',
    total_truck: '车辆数',
    total_pack: '总件数',
    total_weight: '总重量',
    total_volume: '总体积',
    total_deposit: '总押金',
    total_revenue: '总营收',
    fee_ship_vnd: '运费',
    discount_amount: '折扣',
    amount_vnd: '总金额',
    line_amount: '成交金额',
    paid_amount: '已付款',
    remaining_amount: '未付款',
    actions: '操作',
    is_hidden: '是否隐藏',
  }
}